export enum Groep {
	MeetInstrument = 1,
	Energie = 2,
	Beide = 3	
}

export enum GroepFilter {
	MeetInstrument = 1,
	Energie = 2
}